import axios from '../axios-init';

export const getNurseWarehouses = params => {
    return axios.post(`/warehouse/queryWareHouseInfoListForNurse`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getWarehouses = params => {
    return axios.post(`/warehouse/queryWareHouseInfoList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getWarehousesById = params => {
    return axios.post(`/warehouse/queryWareHouseById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const deleteWarehouses = params => {
    return axios.post(`/warehouse/deleteWareHouseById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const addWarehouses = params => {
    return axios.post(`/warehouse/addWareHouse`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getCurrentWarehouse = params => {
    return axios.post(`/warehouse/queryCurrentWareHouse`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getWarehouseForWarehouseAdmin = params => {
    return axios.post(`/warehouse/getWarehouseByUser`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getStorageFeeList = params => {
    return axios.post(`/storageChargeStatistics/getStorageChargeTotal`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const sendEmail = params => {
    return axios.post(`/warehouse/sendUpcMatchEmailToDoctor`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};



// WEBPACK FOOTER //
// ./src/api/warehouseService.js